import React from 'react';
import heroBg from './assets/images/hero-bg.png';
import mp4 from './assets/videos/hero-bg.mp4';
import youbiePng from "./assets/images/youbie.png";
import copyIcon from './assets/images/copy-icon.svg';


const Hero = () => {
    return (
        <div>
                    {/* <!-- Hero --> */}
          <section id="hero" className="hero section">
            <div className="bg__holder">
              <video
                className="bg__video"
                id="bgHeroVideo"
                playsInline
                autoPlay
                muted
                loop
                poster={heroBg}
                >
                <source id="bgVideoSrc" src={mp4} type="video/mp4" />
              </video>
            </div>
            {/* <!--// bg__holder  --> */}
            <source id="bgVideoSrc" src={mp4} type="video/mp4" />
              
            <div className="container">
              <div className="row align-items-center justify-content-end">
                <div className="col-lg-4 order-1 order-md-0"></div>
                <div className="col-lg-8">
                  <div className="hero__content" data-aos="fade-in">
                    <img
                      src={youbiePng}
                      alt="Youbie"
                      className="hero__logo"
                      style={{width:"441px", height:"95px"}}
                    />
                    <h1 className="heading__1">Uncensored Live Streaming</h1>
                    <p className="para">
                      The first crypto powered, DAO operated, all in one live streaming platform
                    </p>
                    <div className="token-search">
                      <form>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            value="To Be Announced"
                            aria-describedby="copy-btn"
                          />
                          <span className="input-group-text" id="copy-btn">
                            <img
                              src={copyIcon}
                              alt="Copy"
                              width="21"
                              height="16"
                            />
                          </span>
                        </div>
                      </form>
                    </div>
                    <div className="button-group">
                      <a href="#" className="you-btn">Buy</a>
                      <a href="#" className="you-btn">Stake</a>
                      <a href="#" className="you-btn">Watch</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <!-- Hero --> */}
        </div>
    );
};

export default Hero;